/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { Random } from "random-js";
import axios from '@/axios.js'
import Handlebars from 'handlebars';
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const speakerRef = con.eventDB.collection(cn).doc('SpeakerList').collection('Speakers')
var attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
var maitmplateRef = con.eventDB.collection(cn).doc("mailtpl").collection("Speaker");
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var Sesion_EventAccessType = ls.getSessionValueByKey('Sesion_EventAccessType');
var eventRef = con.eventDB.collection(cn).doc("EventInfo");
var clientRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id);
var userEventsRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents');
var maitmplateRef = con.eventDB.collection(cn).doc("mailtpl").collection("Speaker");

var BULKEMAILAPIURL = con.BULKEMAILAPIURL;
var BULKMAILAPINEW = con.BULKMAILAPINEW;
var AddSpeakerAPI = con.AddSpeakerAPI;
var DeleteAttendeeApiKey = con.DeleteAttendeeApiKey;


export default {
    fetchSpeakers({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            speakerRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data();
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    docObj.HideInList = docObj.HideInList ? docObj.HideInList : false;
                    markers.push(docObj)
                })
                commit('SET_SPEAKERS', markers)
                resolve(markers)
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchSpeaker(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        Name: '',
                        Company: '',
                        CreateDate: '',
                        Designation: '',
                        Email: '',
                        IsAttendee: false,
                        FirstName: '',
                        Group: '',
                        LastModifiedDate: '',
                        LastName: '',
                        Phone: '',
                        Profile: '',
                        ProfilePictureURL: '',
                        SpeakerId: '',
                        Website: '',
                        IsPublished: true,
                        Resources: [],
                        SocialLinks: [
                            { Facebook: '' },
                            { Twitter: '' },
                            { GooglePlus: '' },
                            { LinkedIn: '' }
                        ],
                    }
                })
            } else {
                let docObj = new Object
                speakerRef.doc(`${id}`).get().then(function (doc) {
                    docObj = doc.data()
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    docObj.IsAttendee = docObj.IsAttendee ? docObj.IsAttendee : false;
                    docObj.SocialLinks = {
                        /*Facebook:doc.data().SocialLinks[0].Facebook,
                        Twitter:doc.data().SocialLinks[3].Twitter,
                        GooglePlus:doc.data().SocialLinks[1].GooglePlus,
                        LinkedIn:doc.data().SocialLinks[2].LinkedIn*/
                    }
                    if (doc.data().SocialLinks) {
                        for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                            let socialkeys = Object.keys(doc.data().SocialLinks[i])
                            let socialvaues = Object.values(doc.data().SocialLinks[i])
                            docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                        }
                    }
                    docObj.Resources = (doc.data().Resources ? doc.data().Resources : [])
                    //console.log(id)                      
                    resolve({ status: 200, data: docObj })                        
                }).catch(function (error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }
        })
    },
    updateStatus(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            speakerRef.doc(`${field.id}`).update({
                IsPublished: field.IsPublished,
                LastModifiedDate: new Date()
            })
                .then(function (doc) {
                    attendeeRef.doc(`${field.id}`).update({ IsSpeaker: field.IsPublished }).then(function () {
                        resolve({ status: 200, message: 'Data Updated.' });
                    })
                }).catch(function (error) {
                    reject(error)
                })
        })
    },
    updateHideInList(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            speakerRef.doc(`${field.id}`).update({
                HideInList: field.HideInList,
                LastModifiedDate: new Date()
            })
                .then(function (doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function (error) {
                    reject(error)
                })
        })
    },
    updateSpeaker(context, field) {
        return new Promise((resolve, reject) => {
            var profileUrl = "";
            if (field.data.file) {
                const file = field.data.file
                const metadata = {
                    'contentType': file.type
                }
                console.log("field>>>>>>>",field.data);
                storageRef.child(`${cn}/Speaker/profileImage/${new Date().getTime()}_${file.name}`).putString(field.data.ProfilePictureURL, 'data_url').then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        profileUrl = url.toString()
                        console.log("profileUrl>>>>>>>",profileUrl);
                        let docObj = {
                            AttendeeId: `${field.id}`,
                            Name: `${field.data.FirstName.trim()} ${field.data.LastName.trim()}`,
                            Company: field.data.Company,
                            Designation: field.data.Designation,
                            //Email: field.data.Email.toLowerCase(),
                            FirstName: field.data.FirstName.trim(),
                            Group: field.data.Group,
                            LastModifiedDate: new Date(),
                            LastName: field.data.LastName.trim(),
                            Phone: field.data.Phone,
                            Profile: field.data.Profile,
                            IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                            ProfilePictureURL: profileUrl,
                            Website: field.data.Website
                        }
                        if (field.data.Resources) {
                            docObj.Resources = field.data.Resources.filter(function (element) {
                                return typeof element == 'string';
                            });
                        }
                        //speakerRef.doc(`${field.id}`).update(docObj).then(function(doc) {
                        let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                        let headers = {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${accessToken}`
                            //"x-api-key": DeleteAttendeeApiKey
                        }
                        let requestData = {
                            "key": {
                                "instanceId": "OA_UAT",
                                "clientId": Session_Client_Id,
                                "eventId": Session_Event_Id
                            },
                            "data": docObj,
                        };
                        axios.put(AddSpeakerAPI, requestData, { headers: headers }).then(function (res) {
                            if (res.data.status == 0) {
                                if (field.data.ResourceFiles) {
                                    context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {

                                    })
                                }

                                resolve({ status: 200, message: 'Data & File Updated.' })
                            }
                            else {
                                resolve({ status: 500, message: 'Data Not Updated.' })
                            }
                        }).catch(function (error) {
                            //console.log('Error getting update attendee:', error)
                            reject(error)
                        })
                    }).catch(function (error) {
                    })
                }).catch(function (error) {
                })
            } else {
                let docObj = {};
                if (field.data.ProfilePictureURL) {
                    docObj = {
                        AttendeeId: `${field.id}`,
                        Name: `${field.data.FirstName.trim()} ${field.data.LastName.trim()}`,
                        Company: field.data.Company,
                        Designation: field.data.Designation,
                        //Email: field.data.Email.toLowerCase(),
                        FirstName: field.data.FirstName.trim(),
                        Group: field.data.Group,
                        LastModifiedDate: new Date(),
                        LastName: field.data.LastName.trim(),
                        Phone: field.data.Phone,
                        Profile: field.data.Profile,
                        IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                        ProfilePictureURL: field.data.ProfilePictureURL,
                        Website: field.data.Website
                    }
                } else {
                    docObj = {
                        AttendeeId: `${field.id}`,
                        Name: `${field.data.FirstName.trim()} ${field.data.LastName.trim()}`,
                        Company: field.data.Company,
                        Designation: field.data.Designation,
                        //Email: field.data.Email.toLowerCase(),
                        FirstName: field.data.FirstName.trim(),
                        Group: field.data.Group,
                        LastModifiedDate: new Date(),
                        LastName: field.data.LastName.trim(),
                        Phone: field.data.Phone,
                        Profile: field.data.Profile,
                        IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                        Website: field.data.Website
                    }
                }
            

            if (field.data.Resources) {
                docObj.Resources = field.data.Resources.filter(function (element) {
                    return typeof element == 'string';
                });
            }
            //speakerRef.doc(`${field.id}`).update(docObj).then(function(doc) {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
                //"x-api-key": DeleteAttendeeApiKey
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                },
                "data": docObj,
            };
            axios.put(AddSpeakerAPI, requestData, { headers: headers }).then(function (res) {
                if (res.data.status == 0) {
                    if (field.data.ResourceFiles) {
                        context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {

                        })
                    }

                    resolve({ status: 200, message: 'Data & File Updated.' })
                }
                else {
                    resolve({ status: 500, message: 'Data Not Updated.' })
                }
            }).catch(function (error) {
                //console.log('Error getting update attendee:', error)
                reject(error)
            })
        }
        })
},
addSpeaker(context, field) {
    return new Promise((resolve, reject) => {
        speakerRef.where("Email", ">", "").where("Email", "==", field.data.Email.toLowerCase()).get().then(function (snapShot) {
            var Profileurl = "";
            if (snapShot.empty) {
                if (field.data.file) {
                    const file = field.data.file
                    const metadata = {
                        'contentType': file.type
                    }
                    storageRef.child(`${cn}/Speaker/profileImage/${new Date().getTime()}_${file.name}`).putString(field.data.ProfilePictureURL, 'data_url').then(function (snapshot) {
                        snapshot.ref.getDownloadURL().then(function (url) {
                            Profileurl = url.toString();
                            let docObj = {
                                Name: `${field.data.FirstName.trim()} ${field.data.LastName.trim()}`,
                                Company: field.data.Company,
                                CreatedDate: new Date(),
                                Designation: field.data.Designation,
                                Email: field.data.Email.toLowerCase().trim(),
                                IsAttendee: field.data.IsAttendee,
                                IsSpeaker: field.data.IsAttendee ? true : false, //** need to store in attendee doc
                                FirstName: field.data.FirstName.trim(),
                                Group: field.data.Group,
                                LastModifiedDate: new Date(),
                                LastName: field.data.LastName.trim(),
                                Phone: field.data.Phone,
                                Profile: field.data.Profile,
                                IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                                ProfilePictureURL: Profileurl,
                                //SpeakerId: null,
                                Website: field.data.Website,
                                Resources: [],
                                UserRoles: [{
                                    RoleID: 10,
                                    RoleName: "AppUser"
                                },
                                {
                                    RoleID: 11,
                                    RoleName: "Speaker"
                                }
                                ],
                                SocialLinks: [
                                    { Facebook: '' },
                                    { GooglePlus: '' },
                                    { LinkedIn: '' },
                                    { Twitter: '' }
                                ]
                            }
                            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                            let headers = {
                                "Content-Type": "application/json",
                                'Authorization': `Bearer ${accessToken}`,
                                //"x-api-key": DeleteAttendeeApiKey
                            }
                            let requestData = {
                                "key": {
                                    "instanceId": "OA_UAT",
                                    "clientId": Session_Client_Id,
                                    "eventId": Session_Event_Id
                                },
                                "data": docObj,
                            };
                            axios.post(AddSpeakerAPI, requestData, { headers: headers }).then(function (res) {
                                if (res.data.status == 0) {
                                    let SpeakerId = res.data.result.AttendeeId;
                                    context.dispatch('resourceUpload', { Id: SpeakerId, files: field.data.ResourceFiles }).then(resource => {

                                    })
                                    resolve({ status: 200, message: 'Data Added.', Id: SpeakerId })
                                }
                                else {
                                    resolve({ status: 500, message: 'Data Not Added.', Id: 0 })
                                }
                            }).catch(function (error) {
                                console.log(error)
                                reject(error)
                            })
                        }).catch(function (error) {
                            //console.log('download url '+error)                
                        })
                    }).catch(function (error) {
                        //console.log('imgae upload '+error)                
                    })
                } else {
                    let docObj = {
                        Name: `${field.data.FirstName.trim()} ${field.data.LastName.trim()}`,
                        Company: field.data.Company,
                        CreatedDate: new Date(),
                        Designation: field.data.Designation,
                        Email: field.data.Email.toLowerCase().trim(),
                        IsAttendee: field.data.IsAttendee,
                        IsSpeaker: field.data.IsAttendee ? true : false, //** need to store in attendee doc
                        FirstName: field.data.FirstName.trim(),
                        Group: field.data.Group,
                        LastModifiedDate: new Date(),
                        LastName: field.data.LastName.trim(),
                        Phone: field.data.Phone,
                        Profile: field.data.Profile,
                        IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                        ProfilePictureURL: Profileurl,
                        //SpeakerId: null,
                        Website: field.data.Website,
                        Resources: [],
                        UserRoles: [{
                            RoleID: 10,
                            RoleName: "AppUser"
                        },
                        {
                            RoleID: 11,
                            RoleName: "Speaker"
                        }
                        ],
                        SocialLinks: [
                            { Facebook: '' },
                            { GooglePlus: '' },
                            { LinkedIn: '' },
                            { Twitter: '' }
                        ]
                    }
                    let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                    let headers = {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${accessToken}`,
                        //"x-api-key": DeleteAttendeeApiKey
                    }
                    let requestData = {
                        "key": {
                            "instanceId": "OA_UAT",
                            "clientId": Session_Client_Id,
                            "eventId": Session_Event_Id
                        },
                        "data": docObj,
                    };
                    axios.post(AddSpeakerAPI, requestData, { headers: headers }).then(function (res) {
                        if (res.data.status == 0) {
                            let SpeakerId = res.data.result.AttendeeId;
                            context.dispatch('resourceUpload', { Id: SpeakerId, files: field.data.ResourceFiles }).then(resource => {

                            })
                            resolve({ status: 200, message: 'Data Added.', Id: SpeakerId })
                        }
                        else {
                            resolve({ status: 500, message: 'Data Not Added.', Id: 0 })
                        }
                    }).catch(function (error) {
                        console.log(error)
                        reject(error)
                    })
                }

            } else {
                resolve({ status: 500, message: 'Email Already Exist!.' })
            }

        }).catch(err => { console.log(err) })

    })
},
updateSpeakerSocialDetail(context, field) {
    return new Promise((resolve, reject) => {
        speakerRef.doc(`${field.id}`).update({
            SocialLinks: [
                { Facebook: (field.data.SocialLinks.Facebook ? field.data.SocialLinks.Facebook : '') },
                { GooglePlus: (field.data.SocialLinks.GooglePlus ? field.data.SocialLinks.GooglePlus : '') },
                { LinkedIn: (field.data.SocialLinks.LinkedIn ? field.data.SocialLinks.LinkedIn : '') },
                { Twitter: (field.data.SocialLinks.Twitter ? field.data.SocialLinks.Twitter : '') }
            ]
        })
            .then(function (doc) {
                context.dispatch('attendeeManagement/updateAttendeeSocialDetail', field, {root:true})
                resolve({ status: 200, message: 'Social Data Updated.' })
            }).catch(function (error) {
                //console.log('Error getting update attendee:', error)
                reject(error)
            })
    })
},
async getAutoId(context) {
    //let AutoId = 0;
    let promise = new Promise((resolve, reject) => {
        con.instanceDB.doc("AutoID").get().then(function (doc) {
            if (!doc.exists) {
                con.instanceDB.doc("AutoID").set({ UserId: 0 })
                resolve(1)
            } else {
                con.instanceDB.doc("AutoID").update({
                    UserId: firebase.firestore.FieldValue.increment(1)
                }).then(function () {
                    con.instanceDB.doc("AutoID").get().then(function (doc) {
                        resolve(doc.data().UserId)
                    })
                })
            }
        })
    })

    let AutoId = await promise;
    AutoId = AutoId * 1000;
    return await AutoId.toString();
},
generateNumber(context, numberLength) {
    const random = new Random(); // uses the nativeMath engine
    //const value = random.hex(numberLength);
    const value = random.integer(100000, 999999);
    return value.toString();
},

resourceUpload(context, obj) {
    return new Promise((resolve, reject) => {
        if (obj.files && obj.files.length) {
            let count = 0;
            for (var i = 0; i < obj.files.length; i++) {
                let file = obj.files[i]
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(`${cn}/Speaker/Resources/${file.name}`).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        speakerRef.doc(`${obj.Id}`).update({ Resources: firebase.firestore.FieldValue.arrayUnion(url.toString()) }).then(function (doc) {
                            count = count + 1;
                            if (obj.files.length == count)
                                resolve({ status: 200, message: 'Files Updated.' })
                        })
                    })
                })
            }
        } else {
            resolve({ status: 200, message: 'Files Updated.' })
        }
    })
},
getSettings(context) {
    let promise = new Promise((resolve, reject) => {
        con.eventDB.collection(cn).doc("Settings").collection('Speaker').doc('SpeakerSettings').get().then(function (doc) {
            if (doc.exists) {
                resolve(doc.data())
            } else {
                resolve({ ShowInAttendee: false })
            }

        })
    })
    return promise;
},
saveSettings(context, field) {
    let promise = new Promise((resolve, reject) => {
        con.eventDB.collection(cn).doc("Settings").collection('Speaker').doc('SpeakerSettings').get().then(function (doc) {
            if (field.IsDefaultSettings) {
                field.settingsData.DefaultSettingsLoaded = true;
                context.dispatch('loadDefaultSettings');
            }
            if (doc.exists) {
                con.eventDB.collection(cn).doc("Settings").collection('Speaker').doc('SpeakerSettings').update(field.settingsData)
                resolve({ message: 'Data Updated.' })
            } else {
                con.eventDB.collection(cn).doc("Settings").collection('Speaker').doc('SpeakerSettings').set(field.settingsData)
                resolve({ message: 'Data Updated.' })
            }

        })
    })
    return promise;
},
allSpeakersHILAttendee({commit, state, dispatch}, ShowInAttendee){
    return new Promise((resolve, reject) => {
        var batch = con.eventDB.batch();
        let totallength = state.speakers.length;
        let count = 0;
        state.speakers.forEach((item)=> {
            if(item.Email)
                attendeeRef.doc(`${item.SpeakerId}`).update({"HideInList": !ShowInAttendee ? true : false});
        });
        if(totallength == count){
            resolve({ message: 'Data Updated.' })
        }
    })
},
getAttendeeBySpeakerId(context, SpeakerId){
    return new Promise((resolve, reject) => {
        attendeeRef.doc(`${SpeakerId}`).get().then(doc=>{
            if (doc.exists)
                resolve(doc.data());
            else
                resolve(null);
        })
    })
},
loadDefaultSettings({ commit }) {
    let promise = new Promise((resolve, reject) => {
        maitmplateRef.doc("Reminder").get().then(function (mailtpl) {
            if (mailtpl.exists) {
                resolve("Template Exists")
            }
            else {
                con.instanceDB.doc("mailtpl").collection("Speaker").doc('Reminder').get().then(function (mailtplinstnc) {
                    if (mailtplinstnc.exists) {
                        maitmplateRef.doc('Reminder').set(mailtplinstnc.data()).then(function () {
                            resolve("Template Created from instance")
                        })
                    }
                    else {

                        maitmplateRef.doc('Reminder').set({ designJson: '', html: '', subject: '' }).then(function () {
                            resolve("Blank Template Created")
                        })
                    }
                })
            }
        })
    })
    return promise;
},
changeStatus(context, field) {
    return new Promise((resolve, reject) => {
        let totallength = field.data.length;
        let count = 0;
        for (var i = 0; i < field.data.length; i++) {
            let data = field.data[i]
            speakerRef.doc(`${data.SpeakerId}`)
                .update({ IsPublished: field.Status })
                .then(function () {
                    attendeeRef.doc(`${data.SpeakerId}`).update({ IsSpeaker: field.Status }).then(function () {
                        count = count + 1;
                        if (totallength == count)
                            resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                    })
                })
        }
    }) // end of promise
},
getMailTemplate(context) {
    var html = '';
    let subject = '';
    var count = 0;
    let promise = new Promise((resolve, reject) => {
        clientRef.get().then(function (clientDetail) {
            eventRef.get().then(function (eventDetail) {
                //let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventStartDate.seconds * 1000).toLocaleTimeString('en-US');
                let EndDate = new Date(eventDetail.data().EventEndDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US');

                let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString()
                let StartTime = new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US')

                let formatedText = {
                    CustomDomain: clientDetail.data().CustomDomain,
                    EventName: eventDetail.data().EventFullName,
                    Email: "Email",
                    Password: "Password",
                    FirstName: "First Name",
                    StartDate: StartDate,
                    StartTime: StartTime,
                    EndDate: EndDate,
                    EventAccessCode: atob(eventDetail.data().defaultEP),
                    EventAccessURL: `${clientDetail.data().CustomDomain}/#${eventDetail.data().EventId}`,
                    EventId: eventDetail.data().EventId,
                    //addtocalendarStartDate: addtocalendarStartDate,
                    //addtocalendarEndDate: addtocalendarEndDate,
                    EventBanner: eventDetail.data().EventBanner,
                    ClientName: clientDetail.data().ClientName,
                    ClientAddress: "Client address if present"
                };
                let Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");
                let reminderMailDoc = Sesion_EventAccessType == 'Use Common Event Passcode' ? 'ReminderEventAccess' : 'Reminder';
                maitmplateRef.doc(reminderMailDoc).get().then(function (mailtpl) {
                    if (mailtpl.exists) {
                        let sourcehtml = (mailtpl.data().html ? mailtpl.data().html : '')
                        let template = Handlebars.compile(sourcehtml);
                        let formatedhtml = template(formatedText);
                        html = (formatedhtml ? formatedhtml : 'Template not set!')
                        subject = (mailtpl.data().subject ? mailtpl.data().subject : null)
                        resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                    } else {
                        con.instanceDB.doc("mailtpl").collection("ReminderMail").doc(reminderMailDoc).get().then(function (mailtplinstnc) {
                            if (mailtplinstnc.exists) {
                                maitmplateRef.doc(reminderMailDoc).set({ html: mailtplinstnc.data().html, subject: mailtplinstnc.data().subject }).then(function () {
                                    let sourcehtml = (mailtplinstnc.data().html ? mailtplinstnc.data().html : '')
                                    let template = Handlebars.compile(sourcehtml);
                                    let formatedhtml = template(formatedText);
                                    html = (formatedhtml ? formatedhtml : 'Template not set!')
                                    subject = (mailtplinstnc.data().subject ? mailtplinstnc.data().subject : null)
                                    resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                })
                            } else {
                                html = 'Template not set!'
                                subject = null
                                sourcehtml = null
                                resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                            }

                        })
                    }

                })
            })
        })
    }) // end of promise

    return promise;
},
sendMail(context, field) {
    let promise = new Promise((resolve, reject) => {
        const headers = {
            "Content-Type": "application/json"
        }
        let Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");
        let reminderMailDoc = Sesion_EventAccessType == 'Use Common Event Passcode' ? 'ReminderEventAccess' : 'Reminder';
        var requestData = {
            key:{
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "recipientType": "Speaker",
                "templatePath": `/mailtpl/Speaker/${reminderMailDoc}`
            },
            data: field.data
        }

        axios.post(BULKMAILAPINEW, requestData, { headers: headers }).then((response) => {
            resolve({ status: 200, message: 'Mail sent to Users' })
        })
            .catch((error) => { })

    }) // end of promise

    return promise;

},
deleteResource(context, field) {
    return new Promise((resolve, reject) => {
        speakerRef.doc(`${field.id}`).update({
            Resources: firebase.firestore.FieldValue.arrayRemove(field.name)
        }).then(function (e) {
            resolve({ status: 200, message: 'resource deleted' })
        });
    })
},
removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
        axios.delete(`/api/user-management/users/${userId}`)
            .then((response) => {
                commit('REMOVE_RECORD', userId)
                resolve(response)
            })
            .catch((error) => { reject(error) })
    })
}
}